import { createReducer, on } from '@ngrx/store';

import * as EndpointActions from './endpoint.actions';
import { Endpoint } from '../../../core/domain/endpoint/endpoint';
import { IFormMode } from '../../types/IFormMode';

export interface EndpointState {
  isModalOpen: boolean;
  formMode?: IFormMode;
  openedEndpoint?: Endpoint;
  providerId?: string;
}

export const initialState: EndpointState = {
  isModalOpen: false,
  formMode: undefined,
  openedEndpoint: undefined,
  providerId: undefined,
};

export const endpointReducer = createReducer(
  initialState,

  on(EndpointActions.openEndpointModal, (state, action) => ({
    ...state,
    isModalOpen: true,
    formMode: action.mode,
    openedEndpoint: action.endpoint || undefined,
    providerId: action.providerId,
  })),
  on(EndpointActions.closeEndpointModal, (state) => ({
    ...state,
    isModalOpen: false,
    formMode: undefined,
    openedEndpoint: undefined,
    providerId: undefined,
  }))
);
